import {
  SourcingAutomatedAction,
  SourcingStageStat,
} from 'api-clients/monolith';
import _range from 'lodash/range';
import { FormattedMessage } from 'react-intl';

import EditIcon from '@/assets/icons/edit.svg';
import { Button } from '@/components/ui/button.js';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { EditStageMappings } from '../edit-stage-mappings';
import { Stage } from './stage';

interface StagesProps {
  funnelData: SourcingStageStat[];
  hiringGoalConversionRate: number | null;
  automatedAction: SourcingAutomatedAction | null;
  refetchFunnelData: () => Promise<void>;
}

export function Stages({
  funnelData,
  hiringGoalConversionRate,
  automatedAction,
  refetchFunnelData,
}: StagesProps) {
  return (
    <div className="border-fx-neutral-300 flex flex-1 flex-col gap-4 overflow-y-auto rounded-lg border bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <Typography variant="h6" as="h2">
          <FormattedMessage
            defaultMessage="Stages"
            description="Funnel settings: list of workflow stages with conversion"
          />
        </Typography>

        <EditStageMappings
          funnelData={funnelData}
          hiringGoalConversionRate={hiringGoalConversionRate}
          refetchFunnelData={refetchFunnelData}
        >
          <Button variant="secondary">
            <img src={EditIcon} alt="Edit" />
            <FormattedMessage
              defaultMessage="Edit mapping"
              description="Button: open modal to connect funnel stages to ATS"
            />
          </Button>
        </EditStageMappings>
      </div>

      {funnelData.map(stage => (
        <Stage
          key={stage.stage_type}
          stage={stage}
          automatedAction={automatedAction}
        />
      ))}
    </div>
  );
}

Stages.Skeleton = function StagesSkeleton() {
  return (
    <div className="border-fx-neutral-300 flex flex-1 flex-col gap-4 rounded-lg border bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <Typography variant="h6" as="h2">
          <FormattedMessage
            defaultMessage="Stages"
            description="Funnel settings: list of workflow stages with conversion"
          />
        </Typography>
        <Skeleton className="h-9 w-[142px]" />
      </div>
      {_range(5).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Stage.Skeleton key={index} />
      ))}
    </div>
  );
};
